import { connect } from 'react-redux'
import configpath from 'configpath'

import mapKeys from 'lodash/mapKeys'
import get from 'lodash/get'
import has from 'lodash/has'
import forIn from 'lodash/forIn'
import map from 'lodash/map'
import { BUSINESS_TYPE } from 'utils/Constants'

import { getInvoices } from 'reduxpath/ducks/Project/PaymentConfirmation'

import {
  putStatusPurchaseOrder,
  getPoByOrderId,
  putStatusOrder,
  getProjectById,
  postInvoice,
  putInvoice,
  putInvoiceStatus,
  postPurchaseOrderCreator,
  putPurchaseOrderCreator,
  getQuotationByOrderId,
  setLoadState,
  getInvoiceWithCreator,
  sendEmailOnCompleteProject,
  postReceipt,
  putReceipt,
} from 'reduxpath/ducks/Project/Detail'

import {
  generateTasks,
  putReviewEligible,
  getOrderReview,
} from 'reduxpath/ducks/Project/Management'

import { getProfileById } from 'reduxpath/ducks/Profile/Detail'

import { postRemittance, putRemittance } from 'reduxpath/ducks/Project/Remittance'

import { getPitch, calculatePricesBeforeTax } from 'reduxpath/ducks/Project/Pitch'
import {
  getTaxSerials,
  putTaxSerial,
  putTaxInvoice,
  getTaxInvoices,
} from 'reduxpath/ducks/Tax/List'
import {
  getComments,
  postComments,
  deleteComment,
  setComment,
} from 'reduxpath/ducks/Project/Comment'
import { postTaxInvoice } from 'reduxpath/ducks/Tax/Add'
import { getUserById } from 'reduxpath/ducks/Auth'

import { getTop } from 'reduxpath/ducks/Top'

import { postEmail, postBulkEmail } from 'reduxpath/ducks/Email'

import { getPermission } from 'reduxpath/ducks/Impersonate'

import { generatePDFv2 } from 'reduxpath/ducks/GeneratePDF'

import { buildEmail } from 'utils/BuildEmail'
import { thousandSeparator } from 'utils/NumeralFormat'

import moment from 'moment'

import Detail from './units'

const mapStateToProps = (state, ownProps) => {
  let restrictFields = ['user', 'stared', 'id', 'order', 'order_detail']
  const allData = state.RunProject.allData
  const taskData = state.TaskList.taskData
  const taskStatusList = state.Reference.statusDefinition.task
  const { ProjectDetail, Reference, ProjectPitch, ProjectComment, Auth } = state
  const { countryTax, nextId, prevId } = ProjectDetail
  const gcProfile = Auth.me.profiles.filter(p => p.profileId === 'getcraft')
  const sponsorSlug = Reference.productTypeSlug.sponsor
  const projectSlug = ProjectDetail.data.productType.slug
  const orderStatusDefinition = Reference.statusDefinition.order
  const pitchStatusDefinition = Reference.statusDefinition.pitch
  const projectPrice =
    !!ProjectDetail.quotation.count > 0 && ProjectDetail.quotation.rows[0].total
  ProjectDetail.data.state = orderStatusDefinition[ProjectDetail.data.status]
  if (projectSlug === sponsorSlug) {
    restrictFields = [...restrictFields, ...['priceFrom', 'priceTo']]
  } else {
    restrictFields = [...restrictFields, ...['priceFixed']]
  }
  const pitches = ProjectPitch.data.rows.map(pitch => {
    const p = pitch
    p.state = pitchStatusDefinition[p.status]
    return p
  })
  const isFirstInvoicePaid =
    state.ProjectPaymentConfirmation.invoices.rows.length > 1 &&
    state.ProjectPaymentConfirmation.invoices.rows[0].status === 2
  const pitchSelectedStatus = state.Reference.statusPitch.selected.status
  const selectedPitches = pitches
    .filter(pitch => pitch.status === pitchSelectedStatus)
    .reduce((accumulator, item) => {
      const key = item.profileId
      const grouped = accumulator
      grouped[key] = grouped[key] || []
      grouped[key].push(item)
      return grouped
    }, {})
  const quotationContent =
    ProjectDetail.quotation.rows.length > 0
      ? Object.entries(ProjectDetail.quotation.rows[0]).filter(
          field => restrictFields.indexOf(field[0]) < 0
        )
      : []
  const orderToolContent =
    ProjectDetail.orderTool.rows.length > 0
      ? Object.entries(ProjectDetail.orderTool.rows[0]).filter(
          field => restrictFields.indexOf(field[0]) < 0
        )
      : []
  const poContent =
    ProjectDetail.po.rows.length > 0
      ? Object.entries(ProjectDetail.po.rows[0])
          .filter(field => restrictFields.indexOf(field[0]) < 0)
          .map(po => {
            const poData = po
            if (poData[0] === 'status') {
              poData[1] = Reference.statusDefinition.po[po[1]]
            }
            return poData
          })
      : []
  const projectTop = getTop(state.ProjectDetail.top.rows[0])
  const financeProfile = state.ProfileDetail.financeProfile
  const companyData = {
    legalName: state.ProfileDetail.data.name,
    taxNumber: '',
    address: '',
  }
  if (financeProfile.rows.length > 0) {
    companyData.legalName = financeProfile.rows[0].companyLegalName
    companyData.taxNumber = financeProfile.rows[0].taxNumber
    companyData.address = financeProfile.rows[0].address
  }
  const selectedCreators = []

  Object.keys(selectedPitches).forEach(async profileId => {
    const newCreator = {
      profileId,
      idProfile: selectedPitches[profileId][0].profile.id,
      profileName: selectedPitches[profileId][0].profile.name,
      isVatRegistered: !!selectedPitches[profileId][0].profile.isVatRegistered,
      businessType: selectedPitches[profileId][0].profile.businessType,
      taxNumber: selectedPitches[profileId][0].profile.taxNumber,
      phoneNumber: selectedPitches[profileId][0].profile.phoneNumber,
      creatorId: selectedPitches[profileId][0].user.id,
      name: selectedPitches[profileId][0].user.firstName,
      email: selectedPitches[profileId][0].user.email,
      projectId: selectedPitches[profileId][0].order.id,
      projectName: selectedPitches[profileId][0].order.name,
      currency: selectedPitches[profileId][0].currency,
      profileBankInformation: selectedPitches[profileId][0].profileBankInformation,
      quantity: 0,
      totalPrice: 0,
      finalPrice: 0,
      vat: 0,
      wht: 0,
      selectedServices: selectedPitches[profileId],
      countryTax,
    }
    selectedPitches[profileId].forEach(item => {
      const loanPrice = get(item, 'loan.loanPrice', 0)
      const totalPrice = item.clientPrice + loanPrice
      const gcCommission = item.gcComm
      const subtractComission = totalPrice - gcCommission
      const whtPercentage =
        newCreator.businessType === 'company' ? 0 : countryTax.wht / 100
      const subtractWht = item.whtCreator || 0
      const vat =
        newCreator.businessType === 'company' && newCreator.isVatRegistered
          ? (countryTax.vat / 100) * subtractComission
          : 0
      const finalPrice = subtractComission + vat - subtractWht - loanPrice

      newCreator.gcCommission = gcCommission
      newCreator.vat += vat
      newCreator.quantity += item.quantity
      newCreator.wht += subtractWht
      newCreator.whtPercentage = whtPercentage
      newCreator.totalPrice += totalPrice
      newCreator.finalPrice += finalPrice
    })
    selectedCreators.push(newCreator)
  })
  return {
    ...ownProps,
    taskStatusList,
    taskData,
    allData,
    projectPrice,
    quotationContent,
    poContent,
    orderToolContent,
    isOrderToolSubmitted: !!ProjectDetail.orderTool.rows.length,
    projectInvoices: state.ProjectPaymentConfirmation.invoices.rows,
    clientTaxInvoices: state.TaxList.taxInvoices.rows.filter(t => t.type === 'client'),
    creatorTaxInvoices: state.TaxList.taxInvoices.rows.filter(t => t.type === 'creator'),
    order: ProjectDetail.data,
    orderDetails: ProjectDetail.orderDetails,
    orderReference: ProjectDetail.orderReference,
    nextId,
    prevId,
    isLoading:
      ProjectDetail.isLoading ||
      state.ProjectPaymentConfirmation.isLoading ||
      state.ProjectRemittance.isLoading ||
      state.TaxAdd.isLoading ||
      state.TaxList.isLoading,
    sponsorSlug,
    pitches,
    projectCompletedStatus:
      state.Reference.statusDefinition.statusOrder.projectCompleted.status,
    comments: ProjectComment.data,
    remittances: state.ProjectRemittance.data.rows,
    orderProfiles: ProjectDetail.orderProfiles,
    orderStatusDefinition: Reference.statusDefinition.order,
    poStatusDefinition: Reference.statusDefinition.po,
    poStatus: ProjectDetail.po.rows.length > 0 ? ProjectDetail.po.rows[0].status : -1,
    poId: ProjectDetail.po.rows.length > 0 ? ProjectDetail.po.rows[0].id : '',
    poPendingValue: Reference.poStatus.pending.value,
    poApprovedValue: Reference.poStatus.approved.value,
    poRejectedValue: Reference.poStatus.rejected.value,
    projectTop,
    paramsMerge: {
      profile: state.ProfileDetail.data,
      quotation: state.ProjectDetail.quotation.rows[0],
      userId: state.Auth.me.user.id,
      companyData,
      selectedPitchStatus: pitchSelectedStatus,
      picFinance: {
        email: financeProfile.rows.length > 0 ? financeProfile.rows[0].picEmail : null,
        name: financeProfile.rows.length > 0 ? financeProfile.rows[0].picName : null,
      },
      countryTax,
    },
    invoiceStatus: Reference.invoiceStatus,

    invoiceStatusWaitingConfirmation: Reference.invoiceStatus.waitingConfirmation.status,
    invoiceStatusRejected: Reference.invoiceStatus.rejected.status,
    invoiceStatusWaitingConfirmed: Reference.invoiceStatus.confirmed.status,
    restrictFields,
    projectRunningStatus:
      state.Reference.statusDefinition.statusOrder.projectRunning.status,
    poApprovedStatus: state.Reference.statusDefinition.statusOrder.poApproved.status,
    selectedCreators,
    selectedPitches,
    say: ProjectComment.inputComment,
    admin: {
      user: Auth.me.user.id,
      profile: gcProfile.length > 0 && gcProfile[0].id,
      profileId: 'getcraft',
      email: Auth.me.user.email,
    },
    isFirstInvoicePaid,
    clientName: ProjectDetail.data.user.firstName,
    projectName: ProjectDetail.data.name,
    clientProfileId: ProjectDetail.data.profile.profileId,
    clientEmail: ProjectDetail.data.user.email,
    clientProfile: ProjectDetail.data.profile.name,
    isOrganic: ProjectDetail.data.isOrganic,
    countryTax,
    tabActive: state.ProjectDetail.tabActive,
    paymentPercentage: state.Reference.paymentPercentage,
    pitchSummary: state.ProjectDetail.pitchSummary.data.rows,
    reference: state.Reference,
  }
}

const mapDispatchToProps = dispatch => ({
  goesTopPlatform(profileId, userEmail, profileSlug, typeDestination) {
    return () => {
      dispatch(getPermission(profileId, userEmail, profileSlug, typeDestination))
    }
  },
  handleSubmitComment(orderDetails, order, admin, say) {
    return e => {
      e.preventDefault()
      const { wisp_public_url: wispPublicUrl, wispDev } = configpath
      const url = `${window.location.protocol}//${window.location.host}`
      const baseUrl = url.includes('localhost') ? wispDev : wispPublicUrl
      const params = {
        ...admin,
        order: order.id,
        say: `<p>${say}</p>`,
      }
      let emailData = {
        recipient: [
          {
            admin: 'TRAFFIC',
            type: 'bcc',
          },
          {
            name: order.user.firstName,
            email: order.user.email,
          },
        ],
        category: 'brief-new-comment',
        type: 'client',
        handlebars: {
          name: order.user.firstName,
          projectName: order.name,
          projectId: order.id,
          link: `${baseUrl}/${order.profile.profileId}/project/${order.id}/order`,
        },
      }
      dispatch(postEmail(buildEmail(emailData)))
      orderDetails
        .filter(
          (product, index, self) =>
            !product.isWithdrawn &&
            !product.isRejected &&
            index === self.findIndex(p => p.profile.id === product.profile.id)
        )
        .map(creator =>
          dispatch(
            getUserById(creator.product.updatedBy, userDetails => {
              emailData = {
                ...emailData,
                recipient: [
                  {
                    name: userDetails.firstName,
                    email: userDetails.email,
                  },
                ],
                handlebars: {
                  name: userDetails.firstName,
                  projectName: order.name,
                  projectId: order.id,
                  link: `${baseUrl}/${creator.profile.profileId}/project/${order.id}/order`,
                },
              }
              return dispatch(postEmail(buildEmail(emailData)))
            })
          )
        )
      dispatch(
        postComments(params, () => window.location.replace(`/projects/${order.id}`))
      )
    }
  },
  handleWriteComment(e) {
    dispatch(setComment(e.target.value))
  },
  handleCompleteProject(
    project,
    projectCompletedStatus,
    selectedCreators,
    top,
    projectPrice,
    projectInvoices,
    quotation,
    companyData,
    countryTax,
    picFinance,
    profile,
    selectedPitchStatus,
    userId,
    pitchSummary
  ) {
    const self = this
    return () => {
      const {
        invDeadlineDays,
        invExpiredDays,
        wisp_public_url: wispPublicUrl,
      } = configpath
      const setstatus = top.installmentAmount > 0 ? 8 : projectCompletedStatus
      dispatch(
        putStatusOrder(
          project.id,
          {
            status: setstatus,
          },
          async () => {
            dispatch(getProjectById(project.id))

            const invoiceParam = {
              profile: profile.id,
              order: project.id,
              quotation: quotation.id,
              url: '',
            }

            if (top.installmentAmount) {
              const installments = [...Array(top.installment).keys()]
              installments.forEach(async () => {
                invoiceParam.dueDate = moment()
                  .add(Number(top.daysPayable), 'days')
                  .format()
                invoiceParam.deadlineDate = moment()
                  .add(Number(top.daysPayable) + Number(invDeadlineDays), 'days')
                  .format()
                invoiceParam.expiredDate = moment()
                  .add(Number(top.daysPayable) + Number(invExpiredDays), 'days')
                  .format()
                invoiceParam.subTotal = (top.installmentAmount / 100) * quotation.subTotal
                invoiceParam.processingFee =
                  (top.installmentAmount / 100) * quotation.processingFee
                invoiceParam.vat = (top.installmentAmount / 100) * quotation.vat
                invoiceParam.total =
                  invoiceParam.subTotal + invoiceParam.vat + invoiceParam.processingFee
                invoiceParam.invoiceType = 'settlement'
                invoiceParam.isActive = true

                if (quotation.manageFeeAmount) {
                  invoiceParam.total += quotation.manageFeeAmount
                }

                const resInv = await new Promise(resolve => {
                  dispatch(postInvoice(invoiceParam, res => resolve(res)))
                })

                let handlebars = {
                  name: project.user.firstName,
                  projectName: project.name,
                  amount: `${quotation.currency} ${thousandSeparator(quotation.total)}`,
                  termsOfPayment: top.clientLabel,
                  projectExpired: moment(quotation.expiredDate).format('DD MMMM YYYY'),
                  invoiceNumber: resInv.invoiceNumber,
                  deadline: moment()
                    .add(Number(top.daysPayable) + Number(invDeadlineDays), 'days')
                    .format(),
                  link: `${wispPublicUrl}/${profile.profileId}/project/${project.id}/order?tab=payment&step=invoice`,
                }
                if (top.upfrontAmount > 0 && top.upfrontAmount < 100) {
                  handlebars = {
                    ...handlebars,
                    upfrontLabel:
                      resInv.type === 'upfront'
                        ? top.emailUpfrontLabel
                        : top.emailSettlementLabel,
                    upfrontAmount: `: ${quotation.currency} ${thousandSeparator(
                      resInv.total
                    )}`,
                    isUpfrontLabel: 'From ',
                  }
                }

                const baseUrl = `${window.location.protocol}//${window.location.host}`
                handlebars = {
                  ...handlebars,
                  name: 'Finance Team',
                  link: `${baseUrl}/projects/${project.id}`,
                }
                const emailData = {
                  recipient: [{ admin: 'Collection' }],
                  category: 'upload-tax-invoice',
                  handlebars,
                  type: 'client',
                }
                dispatch(postEmail(buildEmail(emailData)))

                const selectedPitches = await new Promise(resolveFn =>
                  dispatch(
                    getPitch(
                      {
                        order: project.id,
                        status: selectedPitchStatus,
                      },
                      res => resolveFn(res.rows)
                    )
                  )
                )
                dispatch(
                  putInvoice(resInv.id, {
                    url: await new Promise(resolve => {
                      const generatedData = {
                        type: 'invoice',
                        id: resInv.id,
                        clientProfileId: resInv.profile,
                        orderId: resInv.order,
                        clientUserId: userId,
                        number: resInv.invoiceNumber,
                        expiredDate: resInv.expiredDate,
                        subTotal: resInv.subTotal,
                        vat: resInv.vat,
                        processingFee: resInv.processingFee,
                        total: resInv.total,
                        getPaidPercentage: 0,
                        getPaidAmount: 0,
                      }

                      if (project.isManaged) {
                        generatedData.manageFeeAmount = quotation.manageFeeAmount
                        generatedData.manageFeePercentage = project.managePrctgFee
                      }

                      if (selectedPitches[0].loan) {
                        const [pitch] = selectedPitches
                        generatedData.getPaidPercentage = pitch.loan.loanPercentage
                        generatedData.getPaidAmount = pitch.loan.loanPrice
                      }

                      const pitchData = [...selectedPitches]
                      selectedPitches.forEach((pitch, index) => {
                        const { pitchLines } = pitch

                        const newPitchLines = []

                        const { businessType } = pitch.profile
                        const gcPercentage = parseFloat(pitch.gcCommPercentage, 10) / 100

                        let whtPercentage = 0
                        if (pitch.isCustomVatWht) {
                          whtPercentage = pitch.whtPercentage / 100
                        } else if (businessType === BUSINESS_TYPE.PERSONAL) {
                          whtPercentage = countryTax.wht / 100
                        }

                        const loanPercentage = pitch.loan
                          ? parseFloat(pitch.loan.loanPercentage, 10) / 100
                          : 0

                        Object.values(pitchLines).forEach(line => {
                          const lineItem = [...line]

                          line.forEach((lineData, indexLine) => {
                            const { total: lineTotal } = calculatePricesBeforeTax(
                              lineData.price,
                              gcPercentage,
                              whtPercentage,
                              loanPercentage
                            )

                            lineItem[indexLine].price = lineTotal
                            lineItem[indexLine].amount = lineTotal * lineData.quantity
                          })
                          newPitchLines.push(lineItem)
                        })

                        delete pitchData[index].user
                        delete pitchData[index].order

                        pitchData[index].pitchLines = newPitchLines
                      })

                      const payloads = {
                        projectName: project.name,
                        currency: quotation.currency,
                        projectTop: top,
                        companyData,
                        generatedData,
                        countryTax,
                        selectedPitches: pitchData,
                      }

                      /// generate invoice PDF
                      dispatch(
                        generatePDFv2(payloads, fileData => {
                          resolve(fileData.data)
                        })
                      )
                    }),
                  })
                )
              })
            }

            setTimeout(() => {
              dispatch(
                getInvoices(
                  { order: project.id },
                  {
                    sort: 'createdAt ASC',
                    limit: 100000,
                    skip: 0,
                  }
                )
              )
              dispatch(
                getInvoiceWithCreator({
                  where: {
                    order: project.id,
                  },
                })
              )
            }, 3500)

            dispatch(
              sendEmailOnCompleteProject(project.id, {
                projectData: project,
                topData: top,
                wispUrl: wispPublicUrl,
                projectPriceData: projectPrice,
                selectedCreatorsData: selectedCreators,
                projectInvoicesData: projectInvoices,
                picFinanceData: picFinance,
              })
            )
          }
        )
      )
    }
  },
  handleLoadMore(currentShow, orderId) {
    return e => {
      e.preventDefault()
      dispatch(
        getComments({
          limit: currentShow + 5,
          sort: 'createdAt DESC',
          search: JSON.stringify({
            order: orderId,
          }),
        })
      )
    }
  },

  handleDeleteComment(commentId, orderId, currentShow) {
    return e => {
      e.preventDefault()
      dispatch(
        deleteComment(commentId, () =>
          dispatch(
            getComments({
              limit: currentShow,
              sort: 'createdAt DESC',
              search: JSON.stringify({
                order: orderId,
              }),
            })
          )
        )
      )
    }
  },

  generatePaymentSlip(selectedCreators, order, adminUser, projectTop, countryTax) {
    const self = this
    return (
      idProfile,
      invoiceId,
      invoiceType,
      profileId,
      totalInvoice,
      index
    ) => async () => {
      const choosenCreator = selectedCreators.filter(sc => sc.idProfile === idProfile)[0]
      const profileBank = choosenCreator.profileBankInformation[0]
      const amountPaid =
        invoiceType === 'upfront'
          ? (projectTop.upfrontAmount / 100) * choosenCreator.finalPrice
          : (projectTop.installmentAmount / 100) * choosenCreator.finalPrice
      const totalEmailAmount =
        invoiceType === 'upfront'
          ? (projectTop.upfrontAmount / 100) * choosenCreator.totalPrice
          : (projectTop.installmentAmount / 100) * choosenCreator.totalPrice
      const redirection = invoiceType === 'upfront' ? 'invoice0' : 'invoice1'
      const remittanceParams = {
        order: order.id,
        profile: idProfile,
        invoice: invoiceId,
        bank: profileBank.bank.id,
        accountNumber: profileBank.accountNumber,
        accountName: profileBank.accountName,
        url: '',
        currency: choosenCreator.currency,
        subTotal: choosenCreator.totalPrice,
        gcCommission: choosenCreator.gcCommission,
        vat: choosenCreator.vat,
        wht: choosenCreator.wht,
        totalPaid: amountPaid,
        paidBy: adminUser,
      }
      const { wisp_public_url: wispPublicUrl } = configpath
      let topLabel = ''
      if (projectTop.upfrontAmount > 0 && projectTop.upfrontAmount < 100) {
        topLabel =
          invoiceType === 'upfront'
            ? projectTop.emailUpfrontLabel
            : projectTop.emailSettlementLabel
      }

      dispatch(
        postRemittance(remittanceParams, async resRemittance => {
          dispatch(
            putRemittance(
              resRemittance.id,
              {
                url: await new Promise(resolve => {
                  const generatedData = {
                    type: 'ra',
                    id: resRemittance.id,
                    clientProfileId: resRemittance.profile,
                    orderId: resRemittance.order,
                    clientUserId: resRemittance.paidBy,
                    subTotal: resRemittance.subTotal,
                    totalPaid: resRemittance.totalPaid,
                    wht: resRemittance.wht,
                    vat: resRemittance.vat,
                    processingFee: resRemittance.gcCommission,
                    total: 0,
                    getPaidPercentage: 0,
                    getPaidAmount: 0,
                  }

                  const companyData = {
                    legalName: choosenCreator.profileName,
                    taxNumber: choosenCreator.taxNumber,
                    address: '',
                    picPhone: choosenCreator.phoneNumber,
                    accountName: choosenCreator.profileBankInformation[0].accountName,
                    accountNumber: choosenCreator.profileBankInformation[0].accountNumber,
                    bank: {
                      name: choosenCreator.profileBankInformation[0].bank.name,
                    },
                  }

                  const [pitch] = choosenCreator.selectedServices.map(selected => ({
                    clientPrice: selected.clientPrice,
                    currency: selected.currency,
                    gcComm: selected.gcComm,
                    whtCreator: selected.whtCreator,
                    idea: selected.idea,
                    price: selected.price,
                    status: selected.status,
                    pitchLineQty: selected.pitchLineQty,
                    quantity: selected.quantity,
                    profile: {
                      name: selected.profile.name,
                      businessType: selected.profile.businessType,
                    },
                    references: selected.references,
                    pitchLines: selected.pitchLines,
                    gcCommPercentage: selected.gcCommPercentage,
                    loan: selected.loan,
                  }))

                  if (pitch.loan) {
                    generatedData.getPaidPercentage = pitch.loan.loanPercentage
                    generatedData.getPaidAmount = pitch.loan.loanPrice
                  }

                  const gcPercentage = parseFloat(pitch.gcCommPercentage, 10) / 100

                  let whtPercentage = 0
                  if (pitch.isCustomVatWht) {
                    whtPercentage = pitch.whtPercentage / 100
                  } else if (pitch.profile.businessType === BUSINESS_TYPE.PERSONAL) {
                    whtPercentage = countryTax.wht / 100
                  }

                  const loanPercentage = pitch.loan
                    ? parseFloat(pitch.loan.loanPercentage, 10) / 100
                    : 0

                  const newPitchLines = []

                  forIn(pitch.pitchLines, pitchLine => {
                    const newPitchLine = map(pitchLine, lineItem => {
                      const { total: lineTotal } = calculatePricesBeforeTax(
                        lineItem.price,
                        gcPercentage,
                        whtPercentage,
                        loanPercentage
                      )

                      return {
                        description: lineItem.description,
                        amount: lineItem.quantity * lineTotal,
                        quantity: lineItem.quantity,
                        unit: lineItem.unit,
                        price: lineTotal,
                        target: lineItem.target,
                      }
                    })
                    newPitchLines.push(newPitchLine)
                  })

                  pitch.pitchLines = newPitchLines

                  const dataCountryTax = { ...countryTax }
                  if (choosenCreator.selectedServices[0].isCustomVatWht) {
                    dataCountryTax.wht = choosenCreator.selectedServices[0].whtPercentage
                  }

                  const payloadGenerate = {
                    projectName: choosenCreator.projectName,
                    currency: choosenCreator.currency,
                    projectTop,
                    companyData,
                    generatedData,
                    countryTax: dataCountryTax,
                    selectedPitches: [pitch],
                  }

                  /// generate remittance pdf
                  dispatch(
                    generatePDFv2(payloadGenerate, fileData => {
                      resolve(fileData.data)
                    })
                  )
                }),
              },
              () => {
                let handlebars = {
                  name: choosenCreator.name,
                  projectName: choosenCreator.projectName,
                  amount: `${choosenCreator.currency} ${thousandSeparator(
                    choosenCreator.totalPrice
                  )}`,
                  termsOfPayment: projectTop.creatorLabel,
                  link: `${wispPublicUrl}/${choosenCreator.profileId}/project/${choosenCreator.projectId}/order?tab=payment&step=${redirection}`,
                }
                if (projectTop.upfrontAmount > 0 && projectTop.upfrontAmount < 100) {
                  handlebars = {
                    ...handlebars,
                    upfrontLabel:
                      invoiceType === 'upfront'
                        ? projectTop.emailUpfrontLabel
                        : projectTop.emailSettlementLabel,
                    upfrontAmount: `: ${choosenCreator.currency} ${thousandSeparator(
                      totalEmailAmount
                    )}`,
                    isUpfrontLabel: 'From ',
                  }
                }
                const emailData = {
                  recipient: [
                    {
                      name: choosenCreator.name,
                      email: choosenCreator.email,
                    },
                    { admin: 'TRAFFIC' },
                  ],
                  category: 'payment-is-sent',
                  type: 'creator',
                  handlebars,
                }
                if (totalInvoice === index + 1) {
                  dispatch(postEmail(buildEmail(emailData)))
                }
                dispatch(
                  getInvoiceWithCreator({
                    where: {
                      order: order.id,
                    },
                  })
                )

                /*

            If OrderReview data exist, send email to creator
            and modified eligibleForReview so creator may
            review the client.

            */
                const orData = {
                  order: order.id,
                  reviewedBy: idProfile,
                  category: 'client',
                }

                dispatch(
                  getOrderReview(orData, async orResponse => {
                    if (orResponse.count > 0) {
                      const putReviewEligibleData = {
                        category: 'client',
                        order: order.id,
                        reviewedBy: idProfile,
                        client: order.profile.id,
                      }

                      dispatch(putReviewEligible(putReviewEligibleData))
                      dispatch(
                        getProfileById(profileId, async profile => {
                          const threeDaysFromNow = moment()
                            .add(3, 'days')
                            .format('LL')
                          const creatorEmailData = await Promise.all(
                            profile.users.map(user =>
                              buildEmail({
                                recipient: [
                                  {
                                    name: user.firstName,
                                    email: user.email,
                                  },
                                ],
                                category: 'client-review',
                                type: 'creator',
                                handlebars: {
                                  firstName: user.firstName,
                                  projectName: order.name,
                                  clientWorkspace: order.profile.name,
                                  reviewDueDate: threeDaysFromNow,
                                  link: `${wispPublicUrl}/${choosenCreator.profileId}/project/${choosenCreator.projectId}/order?tab=task&review=${order.profileId}`,
                                },
                              })
                            )
                          )
                          /* Legacy code where after hitting post remittance, will refresh page */
                          if (totalInvoice === index + 1) {
                            dispatch(postBulkEmail(creatorEmailData))
                          }
                        })
                      )
                    }
                  })
                )
              }
            )
          )
        })
      )
    }
  },

  handleActionPo(
    orderStatus,
    poApprovedValue,
    poRejectedValue,
    project,
    profile,
    quotation,
    top,
    userId,
    companyData,
    selectedPitchStatus,
    picFinance,
    countryTax,
    clientName,
    projectName,
    profileId,
    clientEmail,
    clientProfile,
    selectedPitchesPitch,
    paymentPercentage
  ) {
    const baseUrl = `${window.location.protocol}//${window.location.host}`
    const self = this

    return (id, status, orderId) => e => {
      e.preventDefault()

      const data = {
        status,
      }
      const {
        invDeadlineDays,
        invExpiredDays,
        wisp_public_url: wispPublicUrl,
      } = configpath
      let client = [
        {
          name: project.user.firstName,
          email: project.user.email,
        },
      ]
      if (picFinance.email) {
        client = [...client, { ...picFinance, type: 'cc' }]
      }
      const emailCategory = status === poApprovedValue ? 'settle-invoice' : 'invalid-po'
      dispatch(
        putStatusPurchaseOrder(id, data, async () => {
          if (status === poApprovedValue) {
            const setstatus = top.installmentAmount === 100 ? 4 : orderStatus

            dispatch(getProjectById(orderId))

            // Flow for generate PO when approve PO client for TOP 100% settlement

            if (top.installmentAmount === paymentPercentage.fullPayment) {
              const handlebars = {
                name: clientName,
                projectName,
                amount: `${quotation.currency} ${thousandSeparator(quotation.total)}`,
                termsOfPayment: top.clientLabel,
                link: `${wispPublicUrl}/${profileId}/project/${orderId}/order?tab=task`,
              }
              const emailData = {
                recipient: [
                  {
                    name: clientName,
                    email: clientEmail,
                  },
                  { admin: 'TRAFFIC' },
                ],
                category: 'manage-project',
                type: 'client',
                handlebars,
              }
              dispatch(postEmail(buildEmail(emailData)))
            }

            setTimeout(() => {
              dispatch(
                getInvoices(
                  { order: orderId },
                  {
                    sort: 'createdAt ASC',
                    limit: 100000,
                    skip: 0,
                  }
                )
              )
            }, 3500)
          } else {
            const handlebars = {
              name: project.user.firstName,
              projectName: project.name,
              amount: `${quotation.currency} ${thousandSeparator(quotation.total)}`,
              termsOfPayment: top.clientLabel,
              projectExpired: moment(quotation.expiredDate).format('DD MMMM YYYY'),
              link: `${wispPublicUrl}/${profile.profileId}/project/${orderId}/order?tab=payment&step=po`,
            }
            const emailData = {
              recipient: client,
              category: emailCategory,
              type: 'client',
              handlebars,
            }
            dispatch(postEmail(buildEmail(emailData)))
          }
          dispatch(getPoByOrderId(orderId))
        })
      )
    }
  },

  generateTaxInvoice(
    project,
    selectedPitchStatus,
    companyData,
    profile,
    picFinance,
    countryTax
  ) {
    return invoice => async e => {
      e.preventDefault()
      const selectedPitches = await new Promise(resolveFn =>
        dispatch(
          getPitch(
            {
              order: project.id,
              status: selectedPitchStatus,
            },
            res => resolveFn(res.rows)
          )
        )
      )
      const items = selectedPitches.map(pitch => ({
        description: pitch.order_detail.productName,
        quantity: String(pitch.quantity),
        unitPrice: String(pitch.price),
        discount: '0',
        wto: '',
      }))
      const taxSerial = await new Promise(resolveTax =>
        dispatch(
          getTaxSerials(
            {
              sort: 'serialNumber ASC',
              limit: 1,
              search: JSON.stringify({ isUsed: false }),
            },
            res => {
              if (project.currency === 'IDR') {
                dispatch(putTaxSerial(res.rows[0].id))
              }
              resolveTax(res.rows[0])
            }
          )
        )
      )
      let taxInvoiceParams = {
        taxService: {
          invoiceItems: items,
          npwp: companyData.taxNumber || '00.000.000.0-000.000',
          vendor: companyData.legalName,
          documentNumber: taxSerial.serialNumber,
          masaPajak: `0${new Date().getMonth() + 1}`.slice(-2),
          tahunPajak: `${new Date().getFullYear()}`,
          revision: 0,
          vendorAddress: companyData.address || project.country.name,
          vendorCountry: project.country.code,
          vendorPhone: profile.phoneNumber,
          vendorEmail: picFinance.email || project.user.email,
          vatRate: countryTax.vat,
        },
        taxInvoice: {
          order: project.id,
          profile: profile.id,
        },
      }
      taxInvoiceParams = {
        ...taxInvoiceParams,
        taxService: {
          ...taxInvoiceParams.taxService,
          invoiceNumber: invoice.invoiceNumber,
          additionalInformation: invoice.invoiceNumber,
          dueDate: moment(invoice.dueDate).format('YYYY-MM-DD'),
          invoiceDate: moment(invoice.createdAt).format('YYYY-MM-DD'),
        },
        taxInvoice: {
          ...taxInvoiceParams.taxInvoice,
          clientInvoice: invoice.id,
        },
      }
      if (project.currency === 'IDR') {
        dispatch(
          postTaxInvoice(taxInvoiceParams, () => {
            dispatch(
              getTaxInvoices({
                search: JSON.stringify({
                  order: project.id,
                  profile: profile.id,
                  type: 'client',
                }),
              })
            )
          })
        )
      }
    }
  },

  handelActionInvoice(
    invoiceStatusWaitingConfirmed,
    projectRunningStatus,
    project,
    quotation,
    top,
    selectedCreators,
    picFinance,
    isFirstInvoicePaid,
    clientName,
    projectName,
    profileId,
    clientEmail,
    selectedPitches,
    clientProfile,
    countryTax,
    isOrganic,
    companyData,
    pitchSummary,
    reference
  ) {
    const self = this
    return (id, status, orderId) => e => {
      e.preventDefault()
      dispatch(
        putInvoiceStatus(id, { status }, resInv => {
          const baseUrl = `${window.location.protocol}//${window.location.host}`
          const { wisp_public_url: wispPublicUrl } = configpath
          let client = [
            {
              name: project.user.firstName,
              email: project.user.email,
            },
          ]
          if (picFinance.email) {
            client = [...client, { ...picFinance, type: 'cc' }]
          }
          let handlebars = {
            projectName: project.name,
            amount: `${quotation.currency} ${thousandSeparator(quotation.total)}`,
            termsOfPayment: top.clientLabel,
          }
          let emailData = {}
          if (status === invoiceStatusWaitingConfirmed) {
            const setstatus =
              resInv[0].invoiceType === 'settlement' ? 5 : projectRunningStatus
            dispatch(putStatusOrder(orderId, { status: setstatus }))
            handlebars = {
              ...handlebars,
              name: project.user.firstName,
              projectId: orderId,
              invoiceNumber: resInv[0].invoiceNumber,
              actionText:
                resInv[0].type === 'settlement' && top.emailActionFinal
                  ? top.emailActionFinal
                  : top.emailActionSuccess,
              link: `${wispPublicUrl}/${project.profile.profileId}/project/${orderId}/order?tab=payment&step=invoice`,
            }
            if (top.upfrontAmount < 100 && top.upfrontAmount > 0) {
              handlebars = {
                ...handlebars,
                upfrontLabel:
                  resInv[0].type === 'upfront'
                    ? top.emailUpfrontLabel
                    : top.emailSettlementLabel,
                upfrontAmount: `: ${quotation.currency} ${thousandSeparator(
                  resInv[0].total
                )}`,
                isUpfrontLabel: 'From ',
              }
            }
            emailData = {
              recipient: client,
              category: 'payment-success',
              type: 'client',
              handlebars,
            }

            dispatch(
              postReceipt(
                {
                  invoice: resInv[0].id,
                  orderId: project.id,
                },
                receiptPostRes => {
                  let typeReceipt = 'receipt_1'

                  if (
                    project.termsOfPayment.upfrontAmount === 50 &&
                    project.status === 8
                  ) {
                    typeReceipt = 'receipt_2'
                  }

                  const pitchData = []

                  const backupSelectedPitches = JSON.parse(
                    JSON.stringify(selectedPitches)
                  )

                  Object.values(backupSelectedPitches).forEach(pitch => {
                    const newPitchData = { ...pitch[0] }

                    const { pitchLines } = newPitchData

                    const newPitchLines = []

                    const { businessType } = newPitchData.profile
                    const gcPercentage =
                      parseFloat(newPitchData.gcCommPercentage, 10) / 100

                    let whtPercentage = 0
                    if (newPitchData.isCustomVatWht) {
                      whtPercentage = newPitchData.whtPercentage / 100
                    } else if (businessType === BUSINESS_TYPE.PERSONAL) {
                      whtPercentage = countryTax.wht / 100
                    }

                    const loanPercentage = newPitchData.loan
                      ? parseFloat(newPitchData.loan.loanPercentage, 10) / 100
                      : 0

                    Object.values(pitchLines).forEach(line => {
                      const lineItem = [...line]

                      line.forEach((lineData, indexLine) => {
                        const { total: lineTotal } = calculatePricesBeforeTax(
                          lineData.price,
                          gcPercentage,
                          whtPercentage,
                          loanPercentage
                        )

                        lineItem[indexLine].price = lineTotal
                        lineItem[indexLine].amount = lineTotal * lineData.quantity
                      })
                      newPitchLines.push(lineItem)
                    })

                    newPitchData.pitchLines = newPitchLines
                    delete newPitchData.user
                    delete newPitchData.order

                    pitchData.push(newPitchData)
                  })

                  const generatedData = {
                    type: typeReceipt,
                    id: receiptPostRes.data.ID,
                    clientProfileId: project.profile.id,
                    orderId: project.id,
                    clientUserId: project.user.id,
                    number: resInv[0].invoiceNumber,
                    expiredDate: resInv[0].expiredDate,
                    subTotal: resInv[0].subTotal,
                    vat: resInv[0].vat,
                    processingFee: resInv[0].processingFee,
                    total: resInv[0].total,
                    invoiceDate: resInv[0].createdAt,
                    paidAmount: resInv[0].total,
                  }

                  if (project.isManaged) {
                    generatedData.manageFeeAmount = quotation.manageFeeAmount
                    generatedData.manageFeePercentage = project.managePrctgFee
                  }

                  const [selectedPitchSummary] = pitchSummary
                  if (has(selectedPitchSummary, 'loan')) {
                    const [pitch] = selectedPitches[selectedPitchSummary.profileId]
                    generatedData.getPaidPercentage = pitch.loan.loanPercentage
                    generatedData.getPaidAmount = pitch.loan.loanPrice
                  }

                  const payloadGenerateReceipt = {
                    projectName: project.name,
                    currency: project.currency,
                    companyData,
                    countryTax: {
                      vat: countryTax.vat,
                      processingFee: countryTax.processingFee,
                    },
                    generatedData,
                    selectedPitches: pitchData,
                  }

                  /// generate receipt pdf
                  dispatch(
                    generatePDFv2(payloadGenerateReceipt, res => {
                      dispatch(
                        putReceipt(receiptPostRes.data.ID, {
                          invoice: resInv[0].id,
                          orderId: project.id,
                          url: res.data,
                        })
                      )
                    })
                  )
                }
              )
            )

            dispatch(postEmail(buildEmail(emailData)))
            dispatch(
              postEmail(
                buildEmail({
                  ...emailData,
                  recipient: [{ admin: 'TRAFFIC' }, { admin: 'Finance', type: 'cc' }],
                })
              )
            )

            if (top.upfrontAmount < 100 && top.upfrontAmount > 0) {
              handlebars = {
                ...handlebars,
                link: `${baseUrl}/projects/${orderId}`,
              }
              emailData = {
                recipient: [{ admin: 'Finance' }],
                category: 'send-payment',
                type: 'creator',
                handlebars,
              }
              dispatch(postEmail(buildEmail(emailData)))
            }

            if (top.upfrontAmount < 100) {
              pitchSummary.forEach(dataPitch => {
                if (dataPitch.status === reference.statusPitch.selected.status) {
                  const handlebarsConfirmPayment = {
                    Name: dataPitch.user.firstName,
                    projectName: project.name,
                    amount: `${quotation.currency} ${thousandSeparator(
                      dataPitch.payToCreator
                    )}`,
                    link: `${wispPublicUrl}/${dataPitch.profileId}/project/${project.id}/order?tab=payment&step=invoice`,
                    linkProjectPayment: `${wispPublicUrl}/${dataPitch.profileId}/project/${project.id}/order?tab=payment&step=invoice`,
                  }
                  const creator = [
                    {
                      name: dataPitch.user.firstName,
                      email: dataPitch.user.email,
                    },
                  ]

                  const emailDataConfirmPayment = {
                    recipient: creator,
                    category: 'upload-tax-invoice',
                    handlebars: handlebarsConfirmPayment,
                    type: 'creator',
                  }
                  dispatch(postEmail(buildEmail(emailDataConfirmPayment)))
                }
              })
            }

            return dispatch(
              getInvoices(
                { order: orderId },
                {
                  sort: 'createdAt ASC',
                  limit: 100000,
                  skip: 0,
                }
              )
            )
          } else {
            dispatch(
              putInvoice(id, {
                paymentMethod: ``,
              })
            )
          }
          handlebars = {
            name: project.user.firstName,
            projectName: project.name,
            amount: `${quotation.currency} ${thousandSeparator(quotation.total)}`,
            termsOfPayment: top.clientLabel,
            invoiceNumber: resInv[0].invoiceNumber,
            deadline: moment(resInv[0].expiredDate).format('DD MMMM YYYY'),
            link: `${wispPublicUrl}/${project.profile.profileId}/project/${orderId}/order?tab=payment&step=invoice`,
          }
          if (top.upfrontAmount < 100 && top.upfrontAmount > 0) {
            handlebars = {
              ...handlebars,
              upfrontLabel:
                resInv[0].type === 'upfront'
                  ? top.emailUpfrontLabel
                  : top.emailSettlementLabel,
              upfrontAmount: `: ${quotation.currency} ${thousandSeparator(
                resInv[0].total
              )}`,
              isUpfrontLabel: 'From ',
            }
          }
          emailData = {
            recipient: client,
            category: 'payment-failed',
            type: 'client',
            handlebars,
          }
          dispatch(postEmail(buildEmail(emailData)))
          dispatch(
            postEmail(
              buildEmail({
                ...emailData,
                recipient: [{ admin: 'TRAFFIC' }, { admin: 'Finance', type: 'cc' }],
              })
            )
          )
          return dispatch(
            getInvoices(
              { order: orderId },
              {
                sort: 'createdAt ASC',
                limit: 100000,
                skip: 0,
              }
            )
          )
        })
      )
      if (!isFirstInvoicePaid && status === invoiceStatusWaitingConfirmed) {
        if (top.upfrontAmount > 0 || (top.upfrontAmount > 0 && top.upfrontAmount < 100)) {
          const { wisp_public_url: wispPublicUrl } = configpath
          const handlebars = {
            name: clientName,
            projectName,
            amount: `${quotation.currency} ${thousandSeparator(quotation.total)}`,
            termsOfPayment: top.clientLabel,
            link: `${wispPublicUrl}/${profileId}/project/${orderId}/order?tab=task`,
          }
          const emailData = {
            recipient: [
              {
                name: clientName,
                email: clientEmail,
              },
              { admin: 'TRAFFIC' },
            ],
            category: 'manage-project',
            type: 'client',
            handlebars,
          }
          dispatch(postEmail(buildEmail(emailData)))
          const keys = Object.keys(selectedPitches)
          this.forEachPromise(
            selectedPitches,
            projectName,
            clientProfile,
            countryTax,
            top,
            keys,
            self,
            this.dispatchPO
          )
          self.postTasksOnInvoiceApproval(selectedPitches)
        }
      }
    }
  },

  handlePurchaseOrderCreator(
    quotation,
    orderId,
    clientName,
    projectName,
    profileId,
    clientEmail,
    selectedPitches,
    clientProfile,
    countryTax
  ) {
    const { wisp_public_url: wispPublicUrl } = configpath
    const handlebars = {
      name: clientName,
      projectName,
      amount: `${quotation.currency} ${thousandSeparator(quotation.total)}`,
      termsOfPayment: top.clientLabel,
      link: `${wispPublicUrl}/${profileId}/project/${orderId}/order?tab=task`,
    }
    const emailData = {
      recipient: [
        {
          name: clientName,
          email: clientEmail,
        },
        { admin: 'TRAFFIC' },
      ],
      category: 'manage-project',
      type: 'client',
      handlebars,
    }
    dispatch(postEmail(buildEmail(emailData)))
    const keys = Object.keys(selectedPitches)
    this.forEachPromise(
      selectedPitches,
      projectName,
      clientProfile,
      countryTax,
      top,
      keys,
      self,
      this.dispatchPO
    )
  },

  forEachPromise(
    selectedPitches,
    projectName,
    clientName,
    countryTax,
    top,
    items,
    self,
    fn
  ) {
    return items.reduce(
      (promise, item) =>
        promise.then(() =>
          fn(selectedPitches, items, projectName, clientName, countryTax, top, item, self)
        ),
      Promise.resolve()
    )
  },

  dispatchPO(
    selectedPitches,
    totalItems,
    projectName,
    clientName,
    countryTax,
    top,
    item,
    self
  ) {
    return new Promise(resolve => {
      process.nextTick(async () => {
        const defaultProfileBank = {
          accountName: '',
          accountNumber: '',
          bank: {
            name: '',
          },
        }
        const projectId = selectedPitches[item][0].order.id
        const profileId = selectedPitches[item][0].profile.id
        const userId = selectedPitches[item][0].user.id
        const currency = selectedPitches[item][0].order.currency
        const creatorName = selectedPitches[item][0].user.firstName
        const creatorEmail = selectedPitches[item][0].user.email
        const creatorProfile = selectedPitches[item][0].profile.profileId
        const profileBankInformation =
          selectedPitches[item][0].profileBankInformation.length > 1
            ? selectedPitches[item][0].profileBankInformation[0]
            : defaultProfileBank
        const companyData = {
          legalName: selectedPitches[item][0].profile.name,
          taxNumber: selectedPitches[item][0].profile.taxNumber,
          address: '',
          picPhone: selectedPitches[item][0].profile.phoneNumber,
          accountName: profileBankInformation.accountName,
          accountNumber: profileBankInformation.accountNumber,
          bank: {
            name: profileBankInformation.bank.name,
          },
        }
        const poCreatorParams = {
          order: projectId,
          profile: profileId,
          pitch: selectedPitches[item][0].id,
          profileName: selectedPitches[item][0].profile.name,
          serviceName: selectedPitches[item][0].order_detail.productName,
          url: '',
        }
        let amount = 0
        selectedPitches[item].forEach(pitch => {
          amount += pitch.price * pitch.quantity
        })

        const resPO = await new Promise(resolveFn => {
          dispatch(
            postPurchaseOrderCreator(poCreatorParams, res => {
              resolveFn(res)
            })
          )
        })
        dispatch(
          putPurchaseOrderCreator(
            resPO.id,
            {
              url: await new Promise(resolveGenerate => {
                const generatedData = {
                  type: 'po',
                  id: resPO.id,
                  clientProfileId: resPO.profile,
                  orderId: resPO.order,
                  clientUserId: userId,
                  number: resPO.poNumber,
                }

                const pitchData = JSON.parse(JSON.stringify(selectedPitches[item]))
                const { pitchLines } = selectedPitches[item][0]

                const newPitchLines = []

                Object.values(pitchLines).forEach(line => {
                  newPitchLines.push(line)
                })

                pitchData[0].pitchLines = newPitchLines

                delete pitchData[0].user
                delete pitchData[0].order

                const payloadGenerate = {
                  projectName,
                  currency,
                  projectTop: top,
                  companyData,
                  generatedData,
                  countryTax,
                  selectedPitches: pitchData,
                }

                /// generate PO pdf
                dispatch(
                  generatePDFv2(payloadGenerate, fileData => {
                    const { wisp_public_url: wispPublicUrl } = configpath
                    const handlebars = {
                      name: creatorName,
                      clientName,
                      projectName,
                      amount: `${currency} ${thousandSeparator(amount)}`,
                      termsOfPayment: top.creatorLabel,
                      poNumber: resPO.poNumber,
                      actionText: top.emailPOCreator,
                      link: `${wispPublicUrl}/${creatorProfile}/project/${projectId}/order?tab=payment&step=po`,
                    }
                    const emailData = {
                      recipient: [
                        {
                          name: creatorName,
                          email: creatorEmail,
                        },
                      ],
                      category: 'po-creator-sent',
                      type: 'creator',
                      handlebars,
                    }
                    dispatch(postEmail(buildEmail(emailData)))
                    resolveGenerate(fileData.data)
                    resolve()
                  })
                )
              }),
            },
            () => {
              if (totalItems.indexOf(item) === totalItems.length - 1) {
                dispatch(getProjectById(projectId))
                dispatch(getQuotationByOrderId(projectId))
                dispatch(getPoByOrderId(projectId))
                dispatch(setLoadState(false))
              }
            }
          )
        )
      })
    })
  },

  postTasksOnInvoiceApproval(selectedPitches) {
    // -- Turns selectedPitches into array of objects -- //
    let pitches = []
    mapKeys(selectedPitches, val => {
      pitches = [...pitches, ...val]
    })
    // -- Generate data for POST method -- //
    let dispatchData = []
    pitches.forEach((pitch, counter) => {
      const qty = pitch.quantity
      const arrayOfTasks = new Array(qty).fill(pitch).map((data, index) => {
        const task = {
          order: data.order.id,
          orderName: data.order.name,
          profile: data.profile.id,
          clientProfile: data.order.profile,
          pitch: data.id,
          deadline: null,
          name: `${data.order_detail.formatName} ${index + 1}`,
        }
        return task
      })
      dispatchData = [...dispatchData, ...arrayOfTasks]
      if (counter + 1 === pitches.length) {
        dispatch(generateTasks(dispatchData))
      }
    })
  },

  handleSubmitTaxInvoiceUrl(taxInvoiceId, orderId, idProfile) {
    return e => {
      e.preventDefault()
      dispatch(
        putTaxInvoice(
          taxInvoiceId,
          {
            url: e.target.taxInvoiceLink.value,
          },
          () => {
            dispatch(
              getTaxInvoices({
                search: JSON.stringify({
                  order: orderId,
                  profile: idProfile,
                  type: 'client',
                }),
              })
            )
          }
        )
      )
    }
  },
})

function mergeProps(stateProps, dispatchProps) {
  return {
    ...stateProps,
    ...dispatchProps,
    handleCompleteProject: dispatchProps.handleCompleteProject(
      stateProps.order,
      stateProps.projectCompletedStatus,
      stateProps.selectedCreators,
      stateProps.projectTop,
      stateProps.projectPrice,
      stateProps.projectInvoices,
      stateProps.paramsMerge.quotation,
      stateProps.paramsMerge.companyData,
      stateProps.paramsMerge.countryTax,
      stateProps.paramsMerge.picFinance,
      stateProps.paramsMerge.profile,
      stateProps.paramsMerge.selectedPitchStatus,
      stateProps.paramsMerge.userId,
      stateProps.pitchSummary
    ),
    handleActionPo: dispatchProps.handleActionPo(
      stateProps.poApprovedStatus,
      stateProps.poApprovedValue,
      stateProps.poRejectedValue,
      stateProps.order,
      stateProps.paramsMerge.profile,
      stateProps.paramsMerge.quotation,
      stateProps.projectTop,
      stateProps.paramsMerge.userId,
      stateProps.paramsMerge.companyData,
      stateProps.paramsMerge.selectedPitchStatus,
      stateProps.paramsMerge.picFinance,
      stateProps.paramsMerge.countryTax,
      stateProps.clientName,
      stateProps.projectName,
      stateProps.profileId,
      stateProps.clientEmail,
      stateProps.clientProfile,
      stateProps.selectedPitches,
      stateProps.paymentPercentage
    ),
    generateTaxInvoice: dispatchProps.generateTaxInvoice(
      stateProps.order,
      stateProps.paramsMerge.selectedPitchStatus,
      stateProps.paramsMerge.companyData,
      stateProps.paramsMerge.profile,
      stateProps.paramsMerge.picFinance,
      stateProps.paramsMerge.countryTax
    ),
    handelActionInvoice: dispatchProps.handelActionInvoice(
      stateProps.invoiceStatusWaitingConfirmed,
      stateProps.projectRunningStatus,
      stateProps.order,
      stateProps.paramsMerge.quotation,
      stateProps.projectTop,
      stateProps.selectedCreators,
      stateProps.paramsMerge.picFinance,
      stateProps.isFirstInvoicePaid,
      stateProps.clientName,
      stateProps.projectName,
      stateProps.profileId,
      stateProps.clientEmail,
      stateProps.selectedPitches,
      stateProps.clientProfile,
      stateProps.countryTax,
      stateProps.isOrganic,
      stateProps.paramsMerge.companyData,
      stateProps.pitchSummary,
      stateProps.reference
    ),
    handleSubmitComment: dispatchProps.handleSubmitComment(
      stateProps.orderDetails,
      stateProps.order,
      stateProps.admin,
      stateProps.say
    ),
    generatePaymentSlip: dispatchProps.generatePaymentSlip(
      stateProps.selectedCreators,
      stateProps.order,
      stateProps.paramsMerge.userId,
      stateProps.projectTop,
      stateProps.paramsMerge.countryTax
    ),
  }
}

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(Detail)
